
import React, { Fragment, useState } from 'react';
import ButtonIcon from '@visa/vds/button-icon';
import ButtonText from '@visa/vds/button-text';
import Col from '@visa/vds/col';
import Grid from '@visa/vds/grid';
import Icon from '@visa/vds/icon';
import Row from '@visa/vds/row';
import Typography from '@visa/vds/typography';
import Radio from '@visa/vds/radio';
import RadioErrorMessage from '@visa/vds/radio-error-message';
import RadioGroup from '@visa/vds/radio-group';
import RadioGroupControl from '@visa/vds/radio-group-control';
import RadioGroupLegend from '@visa/vds/radio-group-legend';
import Divider from '@visa/vds/divider';
import DateSelector from '@visa/vds/date-selector';
import enUS from 'date-fns/locale/en-US';
import format from 'date-fns/format';
import '../../Style/Store.css';
import DataTable from '@visa/vds/data-table';
import ScreenReader from '@visa/vds/screen-reader';
import Tbody from '@visa/vds/tbody';
import Td from '@visa/vds/td';
import Th from '@visa/vds/th';
import Thead from '@visa/vds/thead';
import Tr from '@visa/vds/tr';
import isValid from 'date-fns/isValid';
import { DateHelper } from '../../../../../_helpers/DateHelper';
import { ProductSelectionConst } from '../SelectProduct/ProductSelectionLogic';
import MCSOverlayLoading from '../../../../../components/MCSOverlayLoading';
import { GetUSDCurrencyString } from '../FeeWaiver/FeeWaiverLogic';


const VSTTSubscriptionDetails = (props) => {
    const isSelected = (productId, subscriptionId) =>{
        console.log("isSelectedCheck",props.subscriptionSelectedMapping)
        var similarProductIndex = props.subscriptionSelectedMapping.findIndex(x => x.productId == productId);
        if (similarProductIndex != -1 && props.subscriptionSelectedMapping)
        {
            return props.subscriptionSelectedMapping[similarProductIndex].subscriptionId == subscriptionId;
        }
        return false;
    }

    const handleSubscriptionSelectedMapping = (productId, subscriptionId,fee) =>{
        var similarProductIndex = props.subscriptionSelectedMapping.findIndex(x => x.productId == productId);
        
        if (similarProductIndex !== -1){
            var currentSubscriptionSelectedList = [...props.subscriptionSelectedMapping]
            currentSubscriptionSelectedList[similarProductIndex].subscriptionId = parseInt(subscriptionId)
            currentSubscriptionSelectedList[similarProductIndex].fee = fee
            props.setSubscriptionSelectedMapping(currentSubscriptionSelectedList)
            
        }else{
            props.setSubscriptionSelectedMapping([...props.subscriptionSelectedMapping, { productId: productId, subscriptionId: parseInt(subscriptionId), fee: fee}])
        }
    }
    const handleSubscriptionMappingDate = (productId, startDate) =>{
        var similarProductIndex = props.subscriptionSelectedStartDate.findIndex(x => x.productId == productId);

        if (similarProductIndex !== -1) {
            var currentSubscriptionSelectedList = [...props.subscriptionSelectedStartDate]
            currentSubscriptionSelectedList[similarProductIndex].startDate = startDate
            props.setSubscriptionSelectedStartDate(currentSubscriptionSelectedList)

        } else {
            props.setSubscriptionSelectedStartDate([...props.subscriptionSelectedStartDate, { productId: productId, startDate: startDate }])
        }
    }

    // if(props.selectedProductInfoDetails.length == 0){
    //     return(
    //         <MCSOverlayLoading/>
    //     )
    // }

    return (
        <>
            <DataTable>
                <ScreenReader tag="caption">Visa Secure Test Tool Select Subscriptions Table</ScreenReader>
                <Thead>
                    <Tr>
                        <Typography tag="h2" scope="col">Visa Secure Test Tools (VSTT)</Typography>
                        <Typography tag="h4">Choose recurring subscription fee type for each subscription that you have selected.</Typography>

                    </Tr>
                </Thead>
                <Tbody>
                    {props.selectedProductInfoDetails && props.selectedProductInfoDetails.map((product, key) => (
                        <Tr key={key}>
                            <Td>
                                <Typography tag="h4"><b>{product.productName}</b></Typography>
                                {product.productPriceMappings.map((productSubscription,subscriptionkey) => (
                                    <Row key={subscriptionkey} noGutter>
                                        <Col lg={10}>
                                            {productSubscription.productInfoId && productSubscription.productInfoId == ProductSelectionConst.VSTT_SETUP &&
                                                <Typography className="vss-field-label"><b>{productSubscription.productInfoName} (One Time Fee)</b></Typography>
                                            }
                                            {productSubscription.productInfoId && productSubscription.productInfoId != ProductSelectionConst.VSTT_SETUP &&
                                                <RadioGroup>
                                                    <Radio
                                                        id={product.productName + " " + productSubscription.productInfoName}
                                                        checked={props.subscriptionSelectedMapping && isSelected(productSubscription.productId, productSubscription.id)}
                                                        label={productSubscription.productInfoName + " (Recurring Fee)"}
                                                        name={"radio-group-subscription-select-" + productSubscription.productId}
                                                        value={productSubscription.id}
                                                        onChange={() => handleSubscriptionSelectedMapping(productSubscription.productId, productSubscription.id,productSubscription.fee)}
                                                    />
                                                </RadioGroup>
                                            }
                                        </Col>
                                        <Col lg={2} textAlign="right" valignCenter>
                                            <Typography id={product.productId + " " + productSubscription.productInfoName}>{GetUSDCurrencyString(productSubscription.fee)}</Typography>
                                        </Col>
                                    </Row>
                                ))}
                                {props.subscriptionSelectErrorList && props.subscriptionSelectErrorList.includes(product.productId) &&
                                    <RadioGroup>
                                    <RadioErrorMessage>
                                    <><Icon
                                        name="error"
                                        resolution="tiny"
                                    />Please select one subscription</>
                                    </RadioErrorMessage>
                                    </RadioGroup>

                                }
                            </Td>
                        </Tr>
                    ))}
                </Tbody>
            </DataTable>
        </>
    );
}

export default VSTTSubscriptionDetails